import { Injectable } from '@angular/core';
import {MediaStorageProvider} from "../media-storage/media-storage";
import {DataReference} from "../../shared/DataReference";
import {Observable} from "rxjs";
import {AngularFireDatabase} from "angularfire2/database";
import {UserInterfacingService} from "../user-interfacing-service/user-interfacing-service";

/*
  Generated class for the UserServiceProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class UserServiceProvider {

  constructor(private uiService: UserInterfacingService,
              private mediaStorage: MediaStorageProvider,
              private afdb: AngularFireDatabase) {

  }

  watchPublicProfile(userId: string) : Observable<UserPublicProfile> {
    return this.afdb.object(DataReference.getUserPublicProfileRef(userId))
      .valueChanges()
      .map(json => UserPublicProfile.fromJson(userId, json));
  }

  savePublicProfile(profile: UserPublicProfile) : Promise<void> {
    return new Promise((resolve, reject) => {
      if (!profile.id) {
        reject('ID missing');
      } else {
        let ref: string = DataReference.getUserPublicProfileRef(profile.id);

        let data = {};
        data[`${ref}/displayName`] = profile.displayName;
        data[`${ref}/photo`] = profile.photo;

        console.log(data);

        this.afdb.database.ref().update(data, err => {
          if (err) {
            console.error(err);
            reject('Error updating profile');
          } else {
            console.log('success');
            resolve();
          }
        });

      }
    });
  }

  updateProfilePhoto(userId: string, image: string) {
    return new Promise((resolve, reject) => {
      let storageRef = MediaStorageProvider.getStorageRefForUserProfilePhoto(userId, 'jpeg');

      this.mediaStorage.uploadPhotoToStorage(storageRef, 'image/jpeg', image).then((downloadUrl) => {
        let ref: string = DataReference.getUserPublicProfileRef(userId);

        let data = {};
        data[`${ref}/photo`] = downloadUrl;

        this.afdb.database.ref().update(data, err => {
          if (err) {
            console.error(err);
            reject('Error updating profile');
          } else {
            resolve();
          }
        });
      });
    });
  }
}

export class UserPublicProfile {

  constructor(public id: string,
              public displayName: string,
              public photo: string = null,
              public tagLine: string = null,
              public isOnline: boolean = false) {
  }

  static fromJson(id: string, data: any) {
    return data == null ? null : this._fromJson(id, data);
  }

  private static _fromJson(id: string, {displayName, photo, isOnline, tagLine}) {
    return new UserPublicProfile(id, displayName, photo, tagLine, isOnline);
  }
}



// WEBPACK FOOTER //
// ./src/providers/user-service/user-service.ts